<template>
    <article class="statistics-block d-flex flex-column align-items-start gap-2">
        <div class="info-wrapper d-flex flex-column row-gap-3 align-items-start flex-wrap text-start">
            <slot name="title">

            </slot>
        </div>
        <div class="visual-wrapper d-flex justify-content-between align-items-end w-100 text-start" :style="[{'--visual-wrapper-height': visualWrapperHeight}]">
            <slot name="correspondingInfo">

            </slot>
            <slot name="chart">

            </slot>
        </div>
    </article>
</template>
<script>
export default {
    data(){
        return {
            barsArray: [
                {
                    height: 30,
                    backgroundColor: "#D9E4FF",
                },
                {
                    height: 60,
                    backgroundColor: "#D9E4FF",
                },
                {
                    height: 100,
                    backgroundColor: "#1E5EFF",
                },
                {
                    height: 70,
                    backgroundColor: "#D9E4FF",
                },
                {
                    height: 80,
                    backgroundColor: "#D9E4FF",
                },
                {
                    height: 50,
                    backgroundColor: "#D9E4FF",
                }
            ],
        }
    },
    props: {
        visualWrapperHeight: {
            type: String,
            default: "45px",
        },
    },
}
</script>
<style scoped>
.statistics-block{
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    column-gap: 0.5em;
    padding: 1.5em;
    background-color: var(--secondary-background-color);
    border-radius: 0.7em;
}
/* .statistics-block > .info-wrapper > p{
    font-size: 48px;
    font-family: "firaGo-700", Helvetica, Arial, sans-serif;
} */
.visual-wrapper{
    height: var(--visual-wrapper-height);
}
@media screen and (max-width: 1560px) {
    .statistics-block{
        padding: 1em;
    }
}
@media screen and (max-width: 992px) {
    .statistics-block{
        padding: 1em;
    }
}
</style>